import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormAddService} from "../../../shared/services/form-add.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Form} from "../../../shared/interface/form";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {delay, distinctUntilChanged, first, takeUntil, tap} from "rxjs/operators";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../shared/services/filter.service";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AddPartnerToFormDialogComponent} from "../add-partner-to-form-dialog/add-partner-to-form-dialog.component";
import {AuthService} from "../../../shared/services/auth.service";
import {NgForm} from "@angular/forms";

@Component({
  selector: 'app-dynamic-form-list',
  templateUrl: './dynamic-form-list.component.html',
  styleUrls: ['./dynamic-form-list.component.scss']
})
export class DynamicFormListComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() embeddedView = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  displayedColumns: string[] = ['name', 'link', 'emailSend', 'active' , 'emailAddressList', 'createdAt'];
  dataSource: Form[] = [];
  totalData = 0;
  initialFilters: any;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  constructor(
    private formAddService: FormAddService,
    private store: Store<StoreRootState>,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private router: Router,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();

    this.formAddService.getFormListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((result: CountedAndPaginated<Form>) => {
        this.dataSource = result.items;
        this.totalData = result.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }
  ngOnInit(): void {
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      contains$name: 'string',
      emailSend: 'int',
      active: 'int',
      gte$createdAt: 'date',
      lte$createdAt: 'date',
      finder: 'string',
    }, filters);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
      this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.displayedColumns = data.displayedColumns ?? this.displayedColumns;
        if (!this.embeddedView) {
          this.store
            .pipe(
              select(getCurrentRouteState),
              delay(0),
              distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
              takeUntil(this.destroyed$),
            )
            .subscribe((state: RouterStateUrl) => {
              this.paginator.pageIndex = state.params.page;
              this.paginator.pageSize = state.params.pageSize;
              this.loadListData();
            });
        } else {
          this.loadListData();
        }
      });
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          ...this.filtersForm.value,
        })]);
    });
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  loadListData(): void {
    this.formAddService.loadList(this.paginator?.pageIndex, this.paginator?.pageSize, this.initialFilters);
  }
}
